<p-chip
  [dt]="disabled ? disabledTokens : null"
  [style]="style"
  [styleClass]="styleClass">
  <div class="flex items-center gap-1">
    @if (icon && icon.length) {
      <span
        class="flex material-symbols-outlined icon-small"
        [class.text-gray-600]="disabled"
        [class.text-blue-600]="!disabled"
        >{{ icon }}</span
      >
    }
    <span [class]="textStyleClass">{{ label }}</span>
    @if (removable) {
      <span
        class="flex material-symbols-outlined icon-small"
        [class.text-gray-600]="disabled"
        [class.text-blue-600]="!disabled"
        [class.cursor-pointer]="!disabled"
        [class.cursor-not-allowed]="disabled"
        (click)="disabled ? $event.stopImmediatePropagation() : removeChip()"
        >close</span
      >
    }
  </div>
</p-chip>
